import { WritableDraft } from "immer";
import values from "lodash/values";
import { areValuesEqual, getEmptyValue, getFiltersSubset } from "PFCore/helpers/filters";
import { FiltersV2, FilterV2 } from "PFTypes/filters_v2";

import { ClearValuesOptions, FiltersV2Data } from "../filters_v2_store.types";

export const clearValues = (filters: WritableDraft<FiltersV2>): FilterV2[] => {
  const filtersToUpdate = values(filters).filter(
    (filter) => !filter.required && !areValuesEqual(getEmptyValue(filter), filter.value)
  );

  filtersToUpdate.forEach((filter) => {
    filter.value = getEmptyValue(filter);
    filter.error = null;
  });

  return filtersToUpdate;
};

export const clearFilterValues = (
  draftState: WritableDraft<FiltersV2Data>,
  { subset }: ClearValuesOptions = {}
) => [
  ...clearValues(getFiltersSubset(draftState.mainFilters, subset)),
  ...clearValues(getFiltersSubset(draftState.childrenFilters, subset))
];
